<div
  class="tw-flex tw-justify-between tw-h-[56px] lg:tw-h-[62px] tw-w-full lg:tw-w-[552px] tw-rounded-lg tw-border tw-bg-white tw-overflow-hidden tw-text-sm tw-leading-tight tw-max-w-full"
  [ngClass]="{
    'tw-border-gray-300': status() === EventStatus.FINISHED,
    'tw-border-yellow-300': status() === EventStatus.UPCOMING,
    'tw-border-green-300': status() === EventStatus.LIVE,
    'tw-border-blue-300': status() === EventStatus.ARCHIVED
  }"
  role="group"
  [attr.aria-label]="'Event dates and status'"
>
  <div class="tw-flex tw-flex-1 tw-items-center tw-gap-1 lg:tw-gap-3 tw-py-1.5 tw-px-2 lg:tw-py-2 lg:tw-px-3 tw-h-auto lg:tw-h-[62px]">
    @if (startParts()) {
      <div class="tw-flex tw-items-center tw-gap-2">
        <div
          class="tw-flex tw-w-[44px] lg:tw-w-[46px] tw-h-[44px] lg:tw-h-[46px] tw-flex-col tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-gray-200 tw-bg-gray-50"
          aria-hidden="true"
        >
          <span class="tw-text-xs tw-font-medium tw-capitalize tw-text-gray-500 tw-font-inter">{{ startParts().weekday }}</span>
          <span class="tw-text-xs lg:tw-text-base tw-font-bold tw-leading-tight tw-text-gray-900 tw-font-inter">{{ startParts().day }}</span>
        </div>
        <span class="tw-whitespace-nowrap tw-font-medium lg:tw-font-bold tw-text-xs lg:tw-text-base tw-text-gray-900 tw-font-inter">{{ startParts().monthYear }}</span>
      </div>
    } @else {
      <span class="tw-text-gray-400">—</span>
    }

    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.913 8.45783C15.9995 8.23906 16.0222 7.99833 15.978 7.76609C15.9339 7.53386 15.8249 7.32055 15.665 7.15317L11.0933 2.36541C10.9878 2.25109 10.8617 2.15991 10.7223 2.09718C10.5828 2.03445 10.4329 2.00143 10.2811 2.00005C10.1294 1.99866 9.97885 2.02895 9.83839 2.08913C9.69793 2.14931 9.57032 2.23819 9.463 2.35057C9.35569 2.46296 9.27083 2.5966 9.21336 2.7437C9.15589 2.8908 9.12697 3.04841 9.12829 3.20734C9.12961 3.36627 9.16114 3.52333 9.22104 3.66936C9.28094 3.81539 9.36801 3.94747 9.47717 4.05788L12.0991 6.80366H1.14293C0.839806 6.80366 0.549097 6.92977 0.334756 7.15423C0.120416 7.3787 0 7.68315 0 8.0006C0 8.31805 0.120416 8.62249 0.334756 8.84696C0.549097 9.07143 0.839806 9.19754 1.14293 9.19754H12.0991L9.47831 11.9421C9.36915 12.0525 9.28208 12.1846 9.22218 12.3306C9.16228 12.4767 9.13075 12.6337 9.12943 12.7927C9.12811 12.9516 9.15703 13.1092 9.2145 13.2563C9.27197 13.4034 9.35683 13.537 9.46415 13.6494C9.57146 13.7618 9.69907 13.8507 9.83953 13.9109C9.97999 13.9711 10.1305 14.0013 10.2823 14C10.434 13.9986 10.584 13.9656 10.7234 13.9028C10.8629 13.8401 10.989 13.7489 11.0944 13.6346L15.6661 8.84683C15.772 8.7354 15.8559 8.60322 15.913 8.45783Z" fill="#9CA3AF"/>
    </svg>        

    @if (endParts()) {
      <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
        <div
          class="tw-flex tw-h-[44px] lg:tw-h-[46px] tw-w-[44px] lg:tw-w-[46px] tw-flex-col tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-gray-200 tw-bg-gray-50"
          aria-hidden="true"
        >
          <span class="tw-font-inter tw-text-xs tw-font-medium tw-capitalize tw-text-gray-500">{{ endParts().weekday }}</span>
          <span class="tw-font-inter tw-text-xs lg:tw-text-base tw-font-bold tw-leading-tight tw-text-gray-900">{{ endParts().day }}</span>
        </div>
        <span class="tw-whitespace-nowrap tw-font-medium lg:tw-font-bold tw-text-xs lg:tw-text-base tw-text-gray-900 tw-font-inter">{{ endParts().monthYear }}</span>
      </div>
    } @else if (isIndefinitelyEvent()) {
      <span
        class="tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center"
        aria-hidden="true"
      >
        <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 4.5625C0 2.03125 2.03125 0 4.53125 0C5.71875 0 6.875 0.5 7.71875 1.34375L10 3.59375L12.25 1.34375C13.0938 0.5 14.25 0 15.4375 0C17.9688 0 20 2.03125 20 4.5625V5.46875C20 7.96875 17.9688 10 15.4375 10C14.25 10 13.0938 9.53125 12.25 8.6875L10 6.4375L7.71875 8.6875C6.875 9.53125 5.71875 10 4.53125 10C2.03125 10 0 7.96875 0 5.46875V4.5625ZM8.5625 5L6.3125 2.75C5.84375 2.28125 5.1875 2 4.53125 2C3.125 2 2 3.15625 2 4.5625V5.46875C2 6.875 3.125 8 4.53125 8C5.1875 8 5.84375 7.75 6.3125 7.28125L8.5625 5ZM11.4062 5L13.6562 7.28125C14.125 7.75 14.7812 8 15.4375 8C16.8438 8 17.9688 6.875 17.9688 5.46875V4.5625C17.9688 3.15625 16.8438 2 15.4375 2C14.7812 2 14.125 2.28125 13.6562 2.75L11.4062 5Z" fill="#111928"/>
          </svg>        
      </span>
    } @else {
      <span class="tw-text-gray-400">—</span>
    }
  </div>

  <div
    class="tw-flex lg:tw-block tw-items-center tw-justify-center tw-py-2 tw-px-2 lg:tw-px-[unset] lg:tw-max-w-[245px]  tw-text-center lg:tw-w-[245px] tw-flex-col lg:tw-py-[18px] tw-h-auto lg:tw-h-[62px] tw-max-w-[96px] tw-w-[96px]"
    [ngClass]="{
      'tw-border-gray-200 tw-bg-gray-300 tw-text-gray-900 lg:tw-min-w-[245px]': status() === EventStatus.FINISHED,
      'tw-border-yellow-300 tw-bg-yellow-100 tw-text-yellow-800  ': status() === EventStatus.UPCOMING,
      'tw-border-green-200 tw-bg-green-100 tw-text-green-800  lg:tw-min-w-[245px]': status() === EventStatus.LIVE,
      'tw-border-blue-200 tw-bg-blue-100 tw-text-blue-800  lg:tw-min-w-[245px]': status() === EventStatus.ARCHIVED
    }"
  >
    @if (showTimer()) {
      <span class="tw-text-center tw-text-xs lg:tw-text-base tw-font-medium tw-tracking-wide tw-text-balance">
        {{ event().is_archived ? 'Archived' : event().status + ':' }}
      </span>
      <span class="tw-text-xs lg:tw-text-base tw-font-medium tw-tracking-wide tw-text-balance">
        {{ timerText() }}
      </span>
    } @else {
      <span
        class="tw-text-center tw-text-xs lg:tw-text-base tw-font-medium tw-tracking-wide tw-text-balance"
        [ngClass]="{ 'tw-uppercase': status() === EventStatus.FINISHED }"
      >
        {{ event().is_archived ? 'Archived' : event().status }}
      </span>
    }
  </div>
</div>
